/**
 * @constant {Object} COLORS
 * @description Defines color codes for various statuses and UI elements.
 */
export const COLORS = {
  /**
   * @property {string} ACTIVE - Represents the color for active status.
   * @value "#09A409" (Green)
   */
  ACTIVE: "#09A409",

  /**
   * @property {string} INACTIVE - Represents the color for inactive status.
   * @value "#dc2626" (Red)
   */
  INACTIVE: "#dc2626",

  /**
   * @property {string} MAINTENANCE - Represents the color for maintenance status.
   * @value "#FF9800" (Orange)
   */
  MAINTENANCE: "#FF9800",

  /**
   * @property {string} DEFAULT - Represents the default color for unspecified statuses.
   * @value "#6B7280" (Gray)
   */
  DEFAULT: "#6B7280",

  /**
   * @property {string} DARK_BLUE - Represents the dark blue theme color used in UI elements.
   * @value "#1a2142" (Dark Blue)
   */
  DARK_BLUE: "#1a2142",

  /**
   * @property {string} SIDEBAR_BG - Background color of the sidebar.
   * @value "#10163A" (Dark Blue)
   */
  SIDEBAR_BG: "#10163A",

  /**
   * @property {string} WHITE - Represents the color white.
   * @value "#ffffff" (White)
   */
  WHITE: "#ffffff",

  /**
   * @property {string} SIDEBAR_ACTIVE_TEXT - Color used for active sidebar text.
   * @value "#10163A" (Dark Blue)
   */
  SIDEBAR_ACTIVE_TEXT: "#10163A",

  /**
   * @property {string} BLUE - Represents the primary blue color used in UI elements.
   * @value "#3B82F6" (Blue)
   */
  BLUE: "#3B82F6",

  /**
   * @property {string} GREEN - Represents the primary green color used in UI elements.
   * @value "#22c55e" (Green)
   */
  GREEN: "#22c55e",

  /**
   * @property {string} DatePickerBackground - Represents the color white.
   * @value "#ffffff" (White)
   */
  DatePickerBackground:  "#ffffff",
}
